import React from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Radio, Spin } from 'antd'

const QUERY = gql`
  query GetCustomerCompanies($customerId: String!) {
    customer(customerNo: $customerId) {
      id
      companies {
        id
        name
      }
    }
  }
`

const optionsParser = customer => {
  if (!customer) return []

  const { companies } = customer

  return companies.map(company => ({
    label: company.name,
    value: company.id
  }))
}

const CartCompanies = ({
  customerId,
  onChange,
  selected
}) => {
  const { data, loading, error } = useQuery(QUERY, {
    variables: { customerId },
    onCompleted: ({ customer }) => {
      const company = customer.companies[0]
      if (!company) return null

      if (company.id !== selected) {
        onChange(company.id)
      }
    }
  })

  if (error) { console.error(error) }
  if (loading) return <Spin />

  const options = optionsParser(data.customer)

  const handleChange = event => {
    onChange(event.target.value)
  }

  return (
    <Radio.Group
      onChange={handleChange}
      options={options}
      value={selected}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }} />
  )
}

CartCompanies.propTypes = {
  customerId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string
}

export default CartCompanies
